<template>
  <section>
    <div class="card pb-3">
      <div class="row">
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center mb-lg-0 mb-3 text-right"
        >
          <div class="row">
            <div
              class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 align-self-center"
            >
              <div
                class="col-filter mr-2 no-mov"
                v-if="partnerType == 'travel_agency'"
              >
                <WSelect
                  placeholder="Agents"
                  v-model="agentId"
                  id="filterAgents"
                  name="filterAgents"
                  filterable
                  indexTab="1"
                  label="Agents"
                  class="select-filter mb-0"
                  clearable
                  @change="filterByAgentId"
                >
                  <el-option
                    v-for="(agent, index) in optionsAgents"
                    :value="agent._id"
                    :label="`${agent.first_name} ${agent.last_name}`"
                    :key="index"
                  ></el-option>
                </WSelect>
              </div>

              <div class="text-left" v-else>
                <h2 class="subtitle mb-0">
                  <i class="flaticon-bold-filter-filled-tool-symbol mr-2"></i>
                  Filters
                </h2>
              </div>
            </div>
            <div
              class="col-xl-7 col-lg-7 col-md-7 col-sm-12 col-12 ml-md-auto ml-0 align-self-center mt-3 mt-md-0 text-right"
            >
              <div
                class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-9 d-inline-block"
              >
                <base-dropdown
                  menu-on-right
                  class="dropfilter"
                  tag="li"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral m-0 dropnocaret"
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button"
                    ><i class="flaticon-calendar mr-1"></i> {{ filtersDate }}
                  </base-button>

                  <div class="row">
                    <div class="col-8" v-on:click.stop.prevent>
                      <base-input label="" disabled="disabled">
                        <flat-picker
                          slot-scope="{ focus, blur }"
                          @on-open="focus"
                          @on-close="blur"
                          :config="{
                            altFormat: formatDateFlatPicker,
                            altInput: true,
                            minDate: 'year',
                            dateFormat: 'Y-m-d',
                            allowInput: true,
                            inline: true,
                            mode: 'range'
                          }"
                          class="input-custom"
                          v-model="filters.date"
                          id="date"
                          name="date"
                          placeholder="Date"
                          tabindex="4"
                        ></flat-picker>
                      </base-input>
                    </div>
                    <div class="col-4">
                      <base-button
                        type="outline-neutral"
                        class="min-button btn-block"
                        @click="filterByDate(today)"
                      >
                        Today
                      </base-button>
                      <base-button
                        type="outline-neutral"
                        class="min-button btn-block"
                        @click="filterByDate(thisWeek)"
                      >
                        This Week
                      </base-button>
                      <base-button
                        type="outline-neutral"
                        class="min-button btn-block"
                        @click="filterByDate(lastWeek)"
                      >
                        Last Week
                      </base-button>
                      <base-button
                        type="outline-neutral"
                        class="min-button btn-block"
                        @click="filterByDate(thisMonth)"
                      >
                        This month
                      </base-button>
                      <base-button
                        type="outline-neutral"
                        class="min-button btn-block"
                        @click="filterByDate(lastMonth)"
                      >
                        Last month
                      </base-button>
                      <base-button
                        type="outline-neutral"
                        class="min-button btn-block"
                        @click="filterByDate(thisYear)"
                      >
                        This Year
                      </base-button>
                      <base-button
                        type="primary"
                        class="min-button btn-block"
                        @click="filterByDate(filters.date)"
                      >
                        Apply
                      </base-button>
                    </div>
                  </div>
                </base-dropdown>
              </div>

              <base-button
                type="outline-neutral"
                class="min-button mb-0 mt-3 mt-sm-0"
                @click="download([])"
              >
                <i class="flaticon-downloading-files"></i>
                Reports
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="row justify-content-center">
        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 box-flex">
          <SimpleCardMetrics
            :title="`${statsCardPrimary.reservations.label}`"
            :percent="`${statsCardPrimary.reservations.percent}`"
            :sub-title="`${statsCardPrimary.reservations.count}`"
            icon="flaticon-contact-list"
            :condition="`${statsCardPrimary.reservations.condition}`"
          >
          </SimpleCardMetrics>
        </div>

        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 box-flex">
          <SimpleCardMetrics
            :title="`${statsCardPrimary.cancellations.label}`"
            :percent="`${statsCardPrimary.cancellations.percent}`"
            :sub-title="`${statsCardPrimary.cancellations.count}`"
            icon="flaticon-traffic-signal"
            :condition="`${statsCardPrimary.cancellations.condition}`"
          >
          </SimpleCardMetrics>
        </div>

        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 box-flex">
          <SimpleCardMetrics
            :title="`${statsCardPrimary.sales.label}`"
            :percent="`${statsCardPrimary.sales.percent}`"
            :sub-title="`${statsCardPrimary.sales.count}`"
            icon="flaticon-team"
            :condition="`${statsCardPrimary.sales.condition}`"
          >
          </SimpleCardMetrics>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 box-flex">
          <SimpleCardMetrics
            :title="`${statsCardPrimary.pay.label}`"
            :percent="`${statsCardPrimary.pay.percent}`"
            :sub-title="`${statsCardPrimary.pay.count}`"
            icon="flaticon-money-back-guarantee"
            :condition="`${statsCardPrimary.pay.condition}`"
          >
          </SimpleCardMetrics>
        </div>
      </div>
    </div>
    <div class="card">
      <h2 class="subtitle">Reservations</h2>
      <div class="container-fluid forms mb-5">
        <div class="row">
          <div
            class="col-xl-5 col-lg-4 col-md-6 col-sm-6 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model.trim="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search Anything..."
                  class="border-none"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-7 col-lg-8 col-md-6 col-sm-6 col-12 alinmov2 align-self-center"
          >
            <div>
              <div class="box-buttons">
                <base-button
                  type="outline-neutral"
                  class="min-button"
                  v-if="activeFilter"
                  @click="resetSearchFilter()"
                >
                  <i class="flaticon-eraser"></i>Reset Search
                </base-button>
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral "
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-rec"></i>
                    <strong>Status</strong>
                  </base-button>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('SBC')"
                  >
                    <i class="flaticon-remove text-cancelled"></i> Cancelled
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('JF')"
                  >
                    <i class="flaticon-check text-completed"></i> Completed
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('SC')"
                  >
                    <i class="flaticon-bold-check-3 text-confirmed"></i>
                    Confirmed
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('BI')"
                  >
                    <i class="flaticon-time-left text-draft"></i> Draft
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('NW')"
                  >
                    <i class="flaticon-add text-new"></i> New
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('BI')"
                  >
                    <i class="flaticon-no-group text-no-show"></i> No Show
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('SRB')"
                  >
                    <i class="flaticon-warning-1 text-rejected"></i>
                    Rejected
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByReservationStatus('PNDG')"
                  >
                    <i class="flaticon-wall-clock-1 text-pending"></i>
                    Pending
                  </div>
                </base-dropdown>
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral "
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-invoice"></i>
                    <strong>Payment</strong>
                  </base-button>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByStatusPayment('paid')"
                  >
                    <i class="flaticon-bold-check-3 text-success"></i> Paid
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByStatusPayment('unpaid')"
                  >
                    <i class="flaticon-wall-clock-1 text-danger"></i> Unpaid
                  </div>
                </base-dropdown>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2"
          >
            <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
              <b-form-radio-group
                id="radio-group-2"
                v-model.trim="filterStatus"
                :aria-describedby="ariaDescribedby"
                name="radio-sub-component"
                button-variant="type-tab"
                buttons
                @change="filteredTab"
                class="buttons-rows"
              >
                <b-form-radio value="all">All</b-form-radio>
                <b-form-radio value="NW"
                  >New
                  <badge type="danger" class="square" v-if="numberNew > 0">{{
                    numberNew
                  }}</badge></b-form-radio
                >

                <b-form-radio value="SRB"
                  >Rejected
                  <badge
                    type="danger"
                    class="square"
                    v-if="numberRejected > 0"
                    >{{ numberRejected }}</badge
                  ></b-form-radio
                >
                <b-form-radio value="unpaid"
                  >Unpaid
                  <badge type="danger" class="square" v-if="numberUnpaid > 0">{{
                    numberUnpaid
                  }}</badge>
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div
            class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 text-right"
          >
            <div
              class="col-xl-7 col-lg-12 col-md-6 ml-auto d-inline-block mb-xl-0 mb-1"
            >
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class="mb-0"
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    @change="applySortBy"
                    :aria-describedby="ariaDescribedby"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2">
              <el-tooltip content="Export" placement="bottom">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="div"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                  title="Export"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-downloading-files mr-0"></i>
                  </base-button>

                  <div
                    class="dropdown-item"
                    @click="
                      download(selectedRows.map(item => item.reservation))
                    "
                    v-if="selectedRows.length > 0"
                  >
                    Selected Records
                  </div>
                  <div class="dropdown-item" @click="download()">
                    All Records
                  </div>
                </base-dropdown>
              </el-tooltip>
            </div>

            <div class="d-inline-block">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  v-if="false"
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>

        <pagination-block
          :pageCount="responseReservations.pages"
          :total="responseReservations.count"
          :limit="limit"
          v-model="currentPage"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          @changeLimit="changeLimit"
          position="bottom"
        ></pagination-block>

        <b-table
          hover
          :items="reservations"
          :fields="fields"
          :sort-by.sync="sortBySync"
          :sort-desc.sync="sortDescSync"
          selectable
          @row-selected="onRowSelected"
          select-mode="multi"
          ref="selectableTable"
          sort-icon-left
          :filter="filterOne"
          show-empty
          empty-filtered-text="There are no records matching your request"
          empty-text="There are no records to show"
          :tbody-transition-props="transProps"
          :stacked="cardview"
          :table-class="getTableClass(reservations)"
          responsive
          sticky-header
        >
          <template #head()="{ label, field: { key } }">
            <span v-if="key === 'selected'">
              <span
                @click="clearSelected"
                v-if="selectedRows.length == reservations.length"
                class="check-table selected"
              ></span>

              <span @click="selectAllRows" v-else class="check-table"></span>
            </span>
            <span v-else>{{ label }}</span>
          </template>
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true" class="check-table selected"></span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true" class="check-table"></span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>

          <template #thead-top="data">
            <draggable
              tag="b-tr"
              v-model="fields"
              @change="changDraggable"
              draggable=".dragg"
              sortable="true"
              :sort="true"
            >
              <b-th
                v-for="(field, index) in fields"
                :key="index"
                class="draggable text-center"
                :class="[
                  {
                    'no-drag': !field.settings.drag,
                    dragg: field.settings.drag,
                    'b-table-sort-icon-left': field.sortable
                  }
                ]"
                style="padding: 0px 10px 10px 10px !important"
                :aria-sort="sortBySync"
                :width="field.width"
              >
                <span class="drag-drop" v-if="field.settings.drag"> </span>
              </b-th>
            </draggable>
          </template>

          <template #cell(booking_number)="data">
            <router-link :to="`/reservations/${data.item.reservation._id}`"
              >{{ data.item.reservation.booking_number }}

              <el-tooltip
                v-if="data.item.reservation.product"
                content="Product"
                placement="bottom"
                ><i class="flaticon-package text-blue ml-1"></i
              ></el-tooltip>
            </router-link>
          </template>

          <template #cell(typeTransfer)="data">
            <span>{{ getBookingType(data.item.reservation.type) }} </span>
          </template>

          <template #cell(reservationtype)="data">
            <div v-if="data.item.reservation.class === 'Transfers'">
              <span
                class="text-capitalize"
                v-if="data.item.reservation.product"
              >
                Experience
              </span>

              <span class="text-capitalize" v-else>Private Transfer</span>
            </div>
            <div v-else>
              <span class="text-capitalize">Experience</span>
            </div>
          </template>

          <template #cell(from)="data">
            <span class="multiline-3">{{ data.item.reservation.from }} </span>
          </template>

          <template #cell(to)="data">
            <span class="multiline-3">{{ data.item.reservation.to }} </span>
          </template>

          <template #cell(pickup_date)="data">
            <span>{{
              getFormatDate(data.item.reservation.pickup_date, formatD)
            }}</span>
            <span class="d-block">{{
              getFormatTime(data.item.reservation.pickup_time, formatT)
            }}</span>
          </template>

          <template #cell(passengersCount)="data">
            <span>{{ data.item.reservation.passengersCount }} </span>
          </template>

          <template #cell(flightNumber)="data">
            <div
              v-if="
                data.item.class === 'Transfers' &&
                  data.item.reservation.type != 'journey'
              "
            >
              <span class="role-table">{{
                getLabelTransport(data.item.reservation.type)
              }}</span>
              <span
                class="d-block"
                :class="{
                  uppercase: getTransportReference(data.item.reservation)
                }"
              >
                {{
                  getTransportReference(data.item.reservation) || "Not included"
                }}</span
              >
            </div>

            <div v-else>
              <span>-</span>
            </div>
          </template>

          <template #cell(customer)="data">
            <ShowAgent
              v-if="data.item.reservation.agent"
              :agent="data.item.reservation.agent"
              :customerId="
                data.item.reservation.customer
                  ? data.item.reservation.customer._id
                  : null
              "
            />
            <ShowCustomer v-else :customer="data.item.reservation.customer" />
          </template>

          <template #cell(passenger)="data">
            <span class="text-capitalize">
              {{
                getPassenger(data.item.passengers, data.item.passengersCount)
              }}
            </span>
          </template>

          <template #cell(service)="data">
            <div v-if="data.item.reservation.class === 'Transfers'">
              <div v-if="data.item.reservation.service">
                <div class="box-img-card">
                  <div class="img-car">
                    <LazyImage
                      :src="
                        data.item.reservation.service.vehicle.information.image
                      "
                      imgClasses="img-fluid es-img-service-2"
                    />
                  </div>

                  <div class="content">
                    <span class="capitalize hide-data title">
                      {{
                        formatCategory(
                          data.item.reservation.service.vehicle.parameters
                            .category
                        )
                      }}
                    </span>

                    <span class="hide-data subtitle-1"
                      >{{
                        data.item.reservation.service.vehicle.parameters.name
                      }}
                      or Similar</span
                    >
                    <span class="hide-data subtitle-1">{{
                      formatVehicleType(
                        data.item.reservation.service.vehicle.parameters.type
                      )
                    }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="">
              <span>-</span>
            </div>
          </template>

          <template #cell(supplier)="data">
            <span class="role-table" v-if="data.item.reservation.branch">{{
              data.item.reservation.branch.name
            }}</span>
            <a
              v-if="data.item.reservation.supplier"
              class="text-capitalize hide-data"
              :href="`/suppliers/${data.item.reservation.supplier._id}`"
              target="_blank"
              >{{ data.item.reservation.supplier.businessDetails.name }}</a
            >
          </template>

          <template #cell(driver)="data">
            <span class="text-capitalize" v-if="data.item.driver">{{
              data.item.driver
            }}</span>
            <span class="text-capitalize text-danger" v-else>Unassigned</span>
          </template>

          <template #cell(referredBy)="data">
            <span v-if="data.item.referredBy">
              {{ data.item.referredBy }}
            </span>
            <span class="text-capitalize" v-else>Direct</span>
          </template>

          <template #cell(quotedPrice)="data">
            <span :class="data.item.quotedPrice < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.quotedPrice }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(netPrice)="data">
            <span :class="data.item.netprice < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.netPrice }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(grossPrice)="data">
            <span :class="data.item.grossprice < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.grossPrice }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(netProfit)="data">
            <span :class="data.item.netprofit < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.netProfit }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(totalExtras)="data">
            <span :class="data.item.totalExtras < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.totalExtras }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(totalDiscounts)="data">
            <span :class="data.item.totalDiscounts < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.totalDiscounts }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(totalCharge)="data">
            <span :class="data.item.totalcharge < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.totalCharge }}
              {{ data.item.currency.code }}</span
            >
          </template>
          <template #cell(stripeFee)="data">
            <span :class="data.item.commission < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.stripeFee }}
              {{ data.item.currency.code }}</span
            >
          </template>
          <template #cell(commission)="data">
            <span :class="data.item.commission < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.commission }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(reservation_reference)="data">
            <span>{{ data.item.reservation.booking_reference }} </span>
          </template>

          <template #cell(paymentreference)="data">
            <span>{{ data.item.reservation.payment_reference }} </span>
          </template>

          <template #cell(deal_number)="data">
            <span>{{ data.item.reservation.deal_number }} </span>
          </template>

          <template #cell(invoicen)="data">
            <span>{{ data.item.reservation.invoice_number }} </span>
          </template>

          <template #cell(source_channel)="data">
            <span class="text-capitalize hide-data">
              {{ data.item.reservation.source.origin }}</span
            >
          </template>

          <template #cell(source_provider)="data">
            <span class="text-capitalize hide-data">
              {{ getSourceProvider(data.item.reservation.source) }}</span
            >
          </template>

          <template #cell(payment)="data">
            <PaymentStatus
              :payment="data.item.reservation.payment"
              :paymentLinkStatus="data.item.reservation.send_payment_link"
              :paymentLink="data.item.reservation.payment_link"
              :paymentType="data.item.reservation.payment_type"
              :status="data.item.reservation.status"
            />
          </template>

          <template #cell(status)="data">
            <div
              class="badge-status"
              v-bind:class="
                statusValue(
                  data.item.reservation.status,
                  data.item.reservation.metadata
                )
              "
            >
              {{ getReservationStatusFormat(data.item.reservation.status) }}
            </div>

            <el-tooltip
              :content="
                statusNew(
                  data.item.reservation.old_status,
                  data.item.reservation.status,
                  data.item.reservation.created_at,
                  data.item.reservation.status_update
                )
              "
              placement="bottom"
              v-if="
                showCircleInfo(
                  data.item.reservation.old_status,
                  data.item.reservation.status,
                  data.item.reservation.created_at,
                  data.item.reservation.status_update
                )
              "
            >
              <span
                class="point-status"
                v-bind:class="
                  addCircleInfo(
                    data.item.reservation.old_status,
                    data.item.reservation.status,
                    data.item.reservation.created_at,
                    data.item.reservation.status_update
                  )
                "
              ></span>
            </el-tooltip>
          </template>

          <template #cell(actions)="data">
            <div v-if="data.item.class === 'Transfers'">
              <div class="action-column">
                <div class="button-action mr-2">
                  <el-tooltip
                    content="History"
                    placement="bottom"
                    class="d-inline-flex"
                  >
                    <span
                      class="icon-action text-blue"
                      @click.stop="
                        openReservationHistory(
                          data.item.reservation._id,
                          data.item.reservation.booking_number
                        )
                      "
                    >
                      <i class="flaticon-wall-clock-1"> </i>
                    </span>
                  </el-tooltip>
                </div>
                <div class="drop-action d-inline-block">
                  <base-dropdown
                    menu-on-right
                    class="nav-item"
                    tag="li"
                    title-tag="a"
                    title-classes="dropnocaret"
                    title="Actions"
                    :direction="getDirection(reservations, data.index)"
                  >
                    <span slot="title">
                      <i class="flaticon-bold-kebab"></i
                    ></span>
                    <div
                      class="dropdown-item"
                      v-if="
                        canConfirmBooking(
                          data.item.reservation.status,
                          data.item.reservation.status_update,
                          data.item.reservation.owner
                        )
                      "
                      @click="
                        confirmBooking(
                          data.item.reservation._id,
                          confirmReservationById
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-bold-check-3 text-confirmed"> </i>
                        Confirm
                      </span>
                    </div>
                    <div
                      class="dropdown-item"
                      v-if="canCancelBooking(data.item.reservation.status)"
                      @click="
                        handlerCancelReservation(
                          data.item.reservation._id,
                          data.item.reservation.pickup_date,
                          data.item.reservation.branch.timezone,
                          data.item.reservation.service.cancellationPolicy,
                          cancelReservationById
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-remove text-cancelled"></i> Cancel
                      </span>
                    </div>
                    <div
                      class="dropdown-item"
                      v-if="
                        canCompleteBooking(data.item.reservation.status) &&
                          calculateHoursDifference(
                            data.item.reservation.pickup_date,
                            data.item.reservation.branch.timezone
                          ) >= 1
                      "
                      @click="
                        completeBooking(
                          data.item.reservation._id,
                          updateBookingStatus
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-check text-completed"></i> Complete
                      </span>
                    </div>

                    <div
                      class="dropdown-item"
                      v-if="
                        canMarkBookingAsNoShow(data.item.reservation.status) &&
                          calculateHoursDifference(
                            data.item.reservation.pickup_date,
                            data.item.reservation.branch.timezone
                          ) >= 1
                      "
                      @click="
                        noShowBooking(
                          data.item.reservation._id,
                          updateBookingStatus
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-no-group text-no-show"></i> Mark as
                        No Show
                      </span>
                    </div>
                    <div
                      class="dropdown-item"
                      v-if="
                        canMarkBookingAsPaid(
                          data.item.reservation.status,
                          data.item.reservation.payment,
                          data.item.reservation.rate.status
                        ) && canUserMarkBookingAsPaid
                      "
                      @click="
                        handlerMarkReservationsAsPaid(
                          [data.item.reservation],
                          markReservationsAsPaidById
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-invoice text-confirmed"></i> Mark as
                        Pay
                      </span>
                    </div>

                    <div
                      class="dropdown-divider"
                      v-if="data.item.reservation.status != 'JF'"
                    ></div>

                    <div
                      class="dropdown-item"
                      v-if="canResendBookingEmail(data.item.reservation.status)"
                      @click="
                        resendNotifications(
                          data.item.reservation._id,
                          data.item.reservation.status,
                          data.item.reservation.class,
                          data.item.reservation.isProssesing,
                          resendEmailNotificationByBookingId
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-envelope text-orange"></i> Resend
                        Email
                      </span>
                    </div>

                    <div
                      class="dropdown-item"
                      v-if="canDownloadQuote(data.item.reservation.status)"
                      @click="
                        downloadPDFType(
                          data.item.reservation._id,
                          data.item.reservation.booking_number,
                          data.item.reservation.product,
                          'quote',
                          data.item.reservation.agent
                            ? data.item.reservation.agent
                            : data.item.reservation.customer
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-web-bill-2"></i>Download Quote
                      </span>
                    </div>
                    <div
                      class="dropdown-item"
                      v-if="canDownloadVoucher(data.item.reservation.status)"
                      @click="
                        downloadPDFType(
                          data.item.reservation._id,
                          data.item.reservation.booking_number,
                          data.item.reservation.product,
                          'voucher',
                          data.item.reservation.agent
                            ? data.item.reservation.agent
                            : data.item.reservation.customer
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-web-bill-2"></i> Download Voucher
                      </span>
                    </div>

                    <div
                      class="dropdown-item"
                      @click="
                        duplicateBooking(
                          data.item.reservation._id,
                          duplicateBookingById
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-copy"></i>Duplicate
                      </span>
                    </div>

                    <div class="dropdown-divider"></div>

                    <div
                      class="dropdown-item"
                      v-if="canUserDelete"
                      @click="
                        deleteBooking(
                          data.item.reservation._id,
                          deleteBookingById
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-delete text-danger"></i>Delete
                      </span>
                    </div>
                  </base-dropdown>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="action-column">
                <div class="button-action mr-2">
                  <el-tooltip
                    content="History"
                    placement="bottom"
                    class="d-inline-flex"
                  >
                    <span
                      class="icon-action text-blue"
                      @click.stop="
                        openReservationHistory(
                          data.item.reservation._id,
                          data.item.reservation.booking_number
                        )
                      "
                    >
                      <i class="flaticon-wall-clock-1"> </i>
                    </span>
                  </el-tooltip>
                </div>
                <div class="drop-action d-inline-block">
                  <base-dropdown
                    menu-on-right
                    class="nav-item"
                    tag="li"
                    title-tag="a"
                    title-classes="dropnocaret"
                    title="Actions"
                    :direction="getDirection(reservations, data.index)"
                  >
                    <span slot="title">
                      <i class="flaticon-bold-kebab"></i
                    ></span>
                    <div
                      class="dropdown-item"
                      v-if="['ON_HOLD'].includes(data.item.reservation.status)"
                      @click="
                        confirmBooking(
                          data.item.reservation._id,
                          otaConfirmReservationById
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-bold-check-3 text-confirmed"> </i>
                        Confirm
                      </span>
                    </div>
                    <div
                      class="dropdown-item"
                      v-if="
                        canMarkBookingAsPaid(
                          data.item.reservation.status,
                          data.item.reservation.payment,
                          false
                        ) && canUserMarkBookingAsPaid
                      "
                      @click="
                        handlerMarkReservationsAsPaid(
                          [data.item.reservation],
                          markReservationsAsPaidById
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-invoice text-confirmed"></i> Mark as
                        Pay
                      </span>
                    </div>
                    <div
                      class="dropdown-item"
                      v-if="
                        ['ON_HOLD', 'CONFIRMED'].includes(
                          data.item.reservation.status
                        )
                      "
                      @click.stop="
                        otaCancelBooking(
                          data.item.reservation._id,
                          otaCancelBookingById
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-remove text-cancelled"></i> Cancel
                      </span>
                    </div>

                    <div
                      class="dropdown-item"
                      v-if="canResendBookingEmail(data.item.reservation.status)"
                      @click="
                        resendNotifications(
                          data.item.reservation._id,
                          data.item.reservation.status,
                          data.item.reservation.class,
                          false,
                          resendEmailNotificationByBookingId
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-envelope text-orange"></i> Resend
                        Email
                      </span>
                    </div>

                    <div
                      class="dropdown-item"
                      v-if="
                        ['CONFIRMED'].includes(data.item.reservation.status)
                      "
                      @click="
                        downloadPDFType(
                          data.item.reservation._id,
                          data.item.reservation.booking_number,
                          data.item.reservation.product,
                          'voucher',
                          data.item.reservation.agent
                            ? data.item.reservation.agent
                            : data.item.reservation.customer
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-web-bill-2"></i> Download Voucher
                      </span>
                    </div>

                    <div
                      class="dropdown-item"
                      v-if="
                        ['CONFIRMED'].includes(data.item.reservation.status)
                      "
                      @click.stop="
                        downloadTickets(
                          data.item.reservation._id,
                          data.item.reservation.agent
                            ? data.item.reservation.agent
                            : data.item.reservation.customer,
                          data.item.reservation.booking_number
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-web-tickets"></i>Download Tickets
                      </span>
                    </div>
                    <div
                      class="dropdown-item"
                      v-if="
                        ['CANCELLED', 'EXPIRED'].includes(
                          data.item.reservation.status
                        ) && canUserDelete
                      "
                      @click="
                        deleteBooking(
                          data.item.reservation._id,
                          deleteBookingById
                        )
                      "
                    >
                      <span class="icon-action">
                        <i class="flaticon-delete text-danger"></i>Delete
                      </span>
                    </div>
                  </base-dropdown>
                </div>
              </div>
            </div>
          </template>
        </b-table>
        <pagination-block
          :pageCount="responseReservations.pages"
          :total="responseReservations.count"
          v-model="currentPage"
          :limit="limit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          @changeLimit="changeLimit"
          position="bottom"
        ></pagination-block>
      </div>
      <ReservationHistory
        :show="showReservationHistory"
        :tempReservationId="tempReservationId"
        :bookingNumber="tempBookingNumber"
        @close="closeReservationHistoryModal"
      />
    </div>
  </section>
</template>

<script>
import moment from "moment-timezone";
import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  ExportAPI,
  ReservationsAPI,
  PartnersAPI,
  SettingsAPI
} from "../../../core/api";
import { DropdownPlugin, TablePlugin } from "bootstrap-vue";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { DropdownMenu, DropdownItem, Dropdown, MessageBox } from "element-ui";
import WSelect from "@/components/Select";
import ReservationHistory from "../../reservations/components/ReservationHistory";
import PaymentStatus from "../../reservations/components/PaymentStatus";
import ShowCustomer from "../../../components/clients/ShowCustomer.vue";
import ShowAgent from "../../../components/clients/ShowAgent.vue";
import lodash from "lodash";
import draggable from "vuedraggable";
import SimpleCardMetrics from "rhomtrip_assets/src/components/Cards/SimpleCardMetrics";
import {
  bulkDeleteBookings,
  calculateHoursDifference,
  canCancelBooking,
  cancelBooking,
  canCompleteBooking,
  canConfirmBooking,
  canDownloadQuote,
  canDownloadVoucher,
  canMarkBookingAsNoShow,
  canMarkBookingAsPaid,
  canResendBookingEmail,
  completeBooking,
  confirmBooking,
  deleteBooking,
  duplicateBooking,
  hasBookingsWithPaymentLink,
  hasCanceledBookings,
  hasExpiredBookings,
  hasPaidBookings,
  markReservationsAsPaid,
  noShowBooking,
  otaCancelBooking,
  PAYMENT_METHODS,
  removeTransferExcludedAttributes,
  resendNotifications,
  sendPaymentLink,
  getLabelTransport,
  getTransportReference,
  resolveRefundEligibility
} from "../../../helpers/reservation.helpers";
import { isUserAuthorized, setSigOut } from "../../../helpers/commons.helpers";
import { RESERVATION_TABLE_DEFAULTS } from "../../../core/constants";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "reservationsPartners",
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [MessageBox.name]: MessageBox,
    DropdownPlugin,
    TablePlugin,
    WSelect: WSelect,
    flatPicker,
    ReservationHistory: ReservationHistory,
    PaymentStatus: PaymentStatus,
    ShowCustomer: ShowCustomer,
    ShowAgent: ShowAgent,
    draggable,
    SimpleCardMetrics
  },
  props: {
    partner: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      limit: 0,
      currentPage: 1,
      selectedRows: [],
      filterOne: null,
      simpleSearch: "",
      filters: {
        date: `${moment()
          .startOf("month")
          .format("YYYY-MM-DD")} to ${moment()
          .endOf("month")
          .format("YYYY-MM-DD")}`,
        customer: "",
        agent: ""
      },
      filtersDate: `${moment()
        .startOf("month")
        .format("YYYY-MM-DD")} to ${moment()
        .endOf("month")
        .format("YYYY-MM-DD")}`,
      filterStatus: "all",
      activeFilter: false,
      isBusy: false,
      transProps: {
        name: "flip-list"
      },
      reservationStatus: "",
      paymentStatus: "",
      query: "",
      queryTemp: "",
      numberNew: 0,
      numberRejected: 0,
      numberUnpaid: 0,
      sortBy: "create_at",
      sortDesc: "desc",
      sortDirection: "asc",
      sortOptions: [
        {
          value: "booking_number",
          text: "Reservation N°"
        },
        {
          value: "pickup_date",
          text: "Date & Time"
        },
        {
          value: "invoice",
          text: "Invoice N°"
        },
        {
          value: "passenger",
          text: "Passenger"
        },
        {
          value: "status",
          text: "Status"
        },
        {
          value: "payment",
          text: "Payment"
        },
        { value: "created_at", text: "Created At" }
      ],
      paymentMethods: PAYMENT_METHODS,
      optionsAgents: [],
      timeoutId: null,
      cardview: false,
      view: "table",
      modalManageColumn: false,
      fields: [],
      visibleSideBar: false,
      statsCardPrimary: {
        reservations: {
          label: "Amount Reservations",
          percent: "3.5",
          count: "10",
          condition: "up"
        },

        cancellations: {
          label: "Amount Cancellations ",
          percent: "3.5",
          count: "5",
          condition: "down"
        },
        pay: {
          label: "Total Payable",
          percent: "3.5",
          count: "$100USD",
          condition: "up"
        },
        sales: {
          label: "Total Sales",
          percent: "3.5",
          count: "$155USD",
          condition: "down"
        }
      },
      agentId: "",
      partnerId: null,
      partnerType: "",
      showReservationHistory: false,
      tempReservationId: "",
      tempBookingNumber: "",
      sortBySync: "",
      sortDescSync: false
    };
  },
  watch: {
    partner: {
      handler: async function(current, old) {
        if (!lodash.isEqual(current, old)) {
          this.partnerId = current.id;
          this.partnerType = current.type;
          await this.initResevationData(this.partnerId, this.partnerType);
        }
      },
      deep: true
    }
  },
  async created() {
    this.getSesion();
    this.fields = this.populateFiles(this.settings);
    this.partnerId = this.partner.id;
    this.partnerType = this.partner.type;
    await this.initResevationData(this.partnerId, this.partnerType);
  },
  methods: {
    canConfirmBooking,
    confirmBooking,
    canCancelBooking,
    canCompleteBooking,
    calculateHoursDifference,
    noShowBooking,
    canMarkBookingAsNoShow,
    canMarkBookingAsPaid,
    canResendBookingEmail,
    canDownloadQuote,
    canDownloadVoucher,
    bulkDeleteBookings,
    duplicateBooking,
    deleteBooking,
    sendPaymentLink,
    otaCancelBooking,
    resendNotifications,
    completeBooking,
    getLabelTransport,
    getTransportReference,
    async initResevationData(partnerId, partnerType) {
      let { query, filters } = this.buildFilters(
        partnerId,
        partnerType,
        this.filters.date
      );
      this.query = query;
      this.filters = filters;
      await this.getLimit();
      this.limit = this.paginationLimit;
      this.filterStatus = "all";
      this.currentPage = 1;
      this.get(false, this.limit, this.currentPage, this.query);
      this.getReservationsMetrics(this.filters);
      await this.getMetadata(this.query);
      if (partnerType === "travel_agency") {
        this.optionsAgents = await this.getOptionsAgentsByPartnerId(partnerId);
      }
    },
    async filterByDate(date) {
      if (date) {
        this.filtersDate = date;
        this.filters.date = date;
        this.filterStatus = "all";
        this.activeFilter = true;
        this.query = this.addElementInQuery(this.query, "date", date);
        this.get(false, this.limit, this.currentPage, this.query);
        this.getReservationsMetrics(this.filters);
        await this.getMetadata(this.query);
      }
    },
    async filterByAgentId(agentId) {
      if (agentId) {
        this.activeFilter = true;
      }
      this.filterStatus = "all";
      this.filters.agent = agentId;
      this.query = agentId
        ? this.addElementInQuery(this.query, "agent", agentId)
        : this.deleteItemInQuery(this.query, ["agent"]);
      this.get(false, this.limit, this.currentPage, this.query);
      this.getReservationsMetrics(this.filters);
      await this.getMetadata(this.query);
    },
    buildFilters(partnerId, partnerType, date) {
      if (partnerType === "travel_access") {
        return {
          filters: {
            agent: partnerId,
            date: date
          },
          query: new URLSearchParams({
            agent: partnerId,
            date: date
          }).toString()
        };
      } else {
        return {
          filters: {
            customer: partnerId,
            date: date
          },
          query: new URLSearchParams({
            customer: partnerId,
            date: date
          }).toString()
        };
      }
    },
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value ? value.trim() : value);
      } else {
        searchParams.append(key, value ? value.trim() : value);
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    async filteredTab(value) {
      if (value === "all") {
        this.currentPage = 1;
        this.queryTemp = "";
        await this.get(true, this.limit, this.currentPage, this.query);
      } else if (value === "NW") {
        this.currentPage = 1;
        if (this.numberNew > 0) {
          this.queryTemp = this.addElementInQuery(this.query, "status", value);
          await this.filterByReservationStatus(this.queryTemp);
        } else {
          this.reservations = [];
        }
      } else if (value === "SRB") {
        this.currentPage = 1;
        if (this.numberRejected > 0) {
          this.queryTemp = this.addElementInQuery(this.query, "status", value);
          await this.filterByReservationStatus(this.queryTemp);
        } else {
          this.reservations = [];
        }
      } else {
        this.currentPage = 1;
        if (this.numberUnpaid > 0) {
          this.queryTemp = this.addElementInQuery(this.query, "payment", value);
          await this.filterByStatusPayment(this.queryTemp);
        } else {
          this.reservations = [];
        }
      }
    },
    deleteEmptyElements(query) {
      return query
        .toString()
        .split("&")
        .filter(element => {
          let [key, value] = element.split("=");
          return key && value ? true : false;
        })
        .join("&");
    },
    async applyAdvancedSearch() {
      this.filterStatus = "all";
      this.activeFilter = true;
      let searchParams = this.buildParams({
        ...Object.fromEntries(new URLSearchParams(this.query)),
        ...this.filters
      });
      this.query = this.deleteEmptyElements(searchParams.toString());
      await this.get(true, this.limit, this.currentPage, this.query);
      await this.getMetadata(this.query);
    },
    async filterByReservationStatus(query) {
      await this.get(true, this.limit, this.currentPage, query);
    },
    async filterByStatusPayment(query) {
      await this.get(true, this.limit, this.currentPage, query);
    },
    async applyFilterByReservationStatus(status) {
      this.filterStatus = "all";
      this.activeFilter = true;
      this.reservationStatus = status;
      this.query = this.addElementInQuery(this.query, "status", status);
      await this.filterByReservationStatus(this.query);
      await this.getMetadata(this.query);
    },
    async applyFilterByStatusPayment(status) {
      this.filterStatus = "all";
      this.activeFilter = true;
      this.paymentStatus = status;
      this.query = this.addElementInQuery(this.query, "payment", status);
      await this.filterByStatusPayment(this.query);
      await this.getMetadata(this.query);
    },
    initFilters(query) {
      if (query) {
        let searchParams = new URLSearchParams(query);
        this.filters.date = searchParams.has("date")
          ? searchParams.get("date")
          : "";
        this.filters.customer = searchParams.has("customer")
          ? searchParams.get("customer")
          : "";
        this.filters.agent = searchParams.has("agent")
          ? searchParams.get("agent")
          : "";
        this.simpleSearch = searchParams.has("search")
          ? searchParams.get("search")
          : "";
        this.reservationStatus = searchParams.has("status")
          ? searchParams.get("status")
          : "";
        this.paymentStatus = searchParams.has("payment")
          ? searchParams.get("payment")
          : "";
      }
    },
    async resetSearchFilter() {
      this.filters.date = `${moment()
        .startOf("month")
        .format("YYYY-MM-DD")} to ${moment()
        .endOf("month")
        .format("YYYY-MM-DD")}`;
      this.filtersDate = this.filters.date;
      let { query, filters } = this.buildFilters(
        this.partnerId,
        this.partnerType,
        this.filters.date
      );
      this.query = query;
      this.filters = filters;
      this.agentId = "";
      this.initFilters(this.query);
      this.filterStatus = "all";
      this.activeFilter = false;
      this.currentPage = 1;
      this.simpleSearch = "";
      this.paymentStatus = "";
      this.reservationStatus = "";
      await this.get(true, this.limit, this.currentPage, this.query);
      this.getReservationsMetrics(this.filters);
      await this.getMetadata(this.query);
    },
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        if (this.filterStatus === "all") {
          this.get(true, this.limit, this.currentPage, this.query);
        } else {
          this.get(true, this.limit, this.currentPage, this.queryTemp);
        }
      }
    },
    previousPaginations(page) {
      if (this.filterStatus === "all") {
        this.get(true, this.limit, page, this.query);
      } else {
        this.get(true, this.limit, page, this.queryTemp);
      }
    },
    nextPaginations(page) {
      if (this.filterStatus === "all") {
        this.get(true, this.limit, page, this.query);
      } else {
        this.get(true, this.limit, page, this.queryTemp);
      }
    },
    changePage(page) {
      if (this.filterStatus === "all") {
        this.get(true, this.limit, page, this.query);
      } else {
        this.get(true, this.limit, page, this.queryTemp);
      }
    },
    async download(reservations = []) {
      try {
        this.setLoad(true);
        let { data } = await ExportAPI.exportCSVReservations(
          this.queryTemp ? this.queryTemp : this.query,
          { reservations: reservations },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `reservations.csv`);
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    onSelectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    statusValue(status, metadata) {
      if (status === "NW") {
        return "status-new";
      } else if (status === "SC") {
        return "status-confirmed";
      } else if (status === "SCB" || status === "SBC") {
        return "status-cancelled";
      } else if (status === "SRB") {
        return "status-rejected";
      } else if (
        status === "DA" ||
        status === "DSR" ||
        status === "DAP" ||
        status === "POB"
      ) {
        return "status-started";
      } else if (status === "JF") {
        return "status-completed";
      } else if (status === "NS") {
        return "status-noshow";
      } else if (status === "BI") {
        return "status-draft";
      } else if (status === "PNDG") {
        if (metadata) {
          if (metadata.creator) {
            return ["travel_agency", "travel_access"].indexOf(
              metadata.creator.type
            ) > -1
              ? "status-new-es"
              : "status-draft";
          } else {
            return "status-draft";
          }
        } else {
          return "status-draft";
        }
      } else {
        return {};
      }
    },
    showCircleInfo(oldStatus, currentstatus, createdAt, statusUpdate) {
      let diff = this.getDifference(createdAt) >= 48;
      if (currentstatus === "NW" && diff) {
        return true;
      } else {
        if (currentstatus === "SC" && oldStatus === "SC" && statusUpdate) {
          return true;
        } else if (
          currentstatus === "SC" &&
          oldStatus === "SC" &&
          !statusUpdate
        ) {
          return true;
        } else if (["SC", "NW"].indexOf(currentstatus) > -1 && statusUpdate) {
          return true;
        } else {
          return false;
        }
      }
    },
    addCircleInfo(oldStatus, currentstatus, createdAt, statusUpdate) {
      let diff = this.getDifference(createdAt) >= 48;
      if (currentstatus === "NW" && diff) {
        return "danger";
      } else {
        if (currentstatus === "SC" && oldStatus === "SC" && statusUpdate) {
          return "warning";
        } else if (
          currentstatus === "SC" &&
          oldStatus === "SC" &&
          !statusUpdate
        ) {
          return "info";
        } else if (["SC", "NW"].indexOf(currentstatus) > -1 && statusUpdate) {
          return "warning";
        } else {
          return "";
        }
      }
    },
    statusNew(oldStatus, currentstatus, createdAt, statusUpdate) {
      let diff = this.getDifference(createdAt) >= 48;
      if (currentstatus === "NW" && diff) {
        return "Pending Confirm";
      } else {
        if (currentstatus === "SC" && oldStatus === "SC" && statusUpdate) {
          return "Updated";
        } else if (
          currentstatus === "SC" &&
          oldStatus === "SC" &&
          !statusUpdate
        ) {
          return "Reconfirm";
        } else if (["SC", "NW"].indexOf(currentstatus) > -1 && statusUpdate) {
          return "Updated";
        } else {
          return "";
        }
      }
    },
    handleError(error, message, title = "Error!") {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: title,
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    async get(loader, limit, page, query) {
      await this.getReservations({
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
    },
    showNotify(action) {
      if (action === "deleted") {
        this.$notify({
          type: "danger",
          title: "Deleted!",
          message: "The Reservation has been Deleted",
          icon: "flaticon-check-3"
        });
      } else if (action === "canceled") {
        this.$notify({
          type: "danger",
          title: "Cancelled!",
          message: "The Reservation has been cancelled",
          icon: "flaticon-check-3"
        });
      } else if (action === "created") {
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The reservations has been created",
          icon: "flaticon-check-3"
        });
      }
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    getDifference(createdAt) {
      return moment(moment().format()).diff(
        moment(createdAt).format(),
        "hours",
        true
      );
    },
    async applySimpleSearch(value) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        this.activeFilter = true;
        if (value) {
          if (this.filterStatus === "all") {
            this.query = this.addElementInQuery(this.query, "search", value);
            await this.get(true, this.limit, this.currentPage, this.query);
            await this.getMetadata(this.query);
          } else {
            let query = this.addElementInQuery(this.queryTemp, "search", value);
            await this.get(true, this.limit, this.currentPage, query);
          }
        } else {
          this.query = this.deleteItemInQuery(this.query, ["search"]);
          await this.get(true, this.limit, this.currentPage, this.query);
          await this.getMetadata(this.query);
        }
      }, 500);
    },

    changeViewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    async getMetadata(query) {
      try {
        let { data } = await ReservationsAPI.getMetadataReservations(
          query,
          this.sesion.token
        );
        if (data.status) {
          let metadata = data.data;
          this.numberNew = metadata.new;
          this.numberRejected = metadata.rejected;
          this.numberUnpaid = metadata.unpaid;
        } else {
          this.numberNew = 0;
          this.numberRejected = 0;
          this.numberUnpaid = 0;
        }
      } catch (error) {
        this.numberNew = 0;
        this.numberRejected = 0;
        this.numberUnpaid = 0;
      }
    },
    async applySortBy(value) {
      if (this.filterStatus === "all") {
        this.query = this.addElementInQuery(this.query, "sortBy", value);
        this.query = this.addElementInQuery(
          this.query,
          "sortType",
          this.sortDesc
        );
        await this.get(true, this.limit, this.currentPage, this.query);
      } else {
        this.queryTemp = this.addElementInQuery(
          this.queryTemp,
          "sortBy",
          value
        );
        this.queryTemp = this.addElementInQuery(
          this.queryTemp,
          "sortType",
          this.sortDesc
        );
        await this.get(true, this.limit, this.currentPage, this.queryTemp);
      }
    },
    async applySortType(value) {
      if (this.filterStatus === "all") {
        this.query = this.addElementInQuery(this.query, "sortType", value);
        await this.get(true, this.limit, this.currentPage, this.query);
      } else {
        this.queryTemp = this.addElementInQuery(
          this.queryTemp,
          "sortType",
          value
        );
        await this.get(true, this.limit, this.currentPage, this.queryTemp);
      }
    },
    async onRowClicked(item) {
      const { detailsRow } = this;
      if (detailsRow && detailsRow !== item) {
        detailsRow._showDetails = false;
      }
      this.$set(item, "_showDetails", !item._showDetails);
      this.detailsRow = item;
    },
    async getOptionsAgentsByPartnerId(partnerId) {
      try {
        let { data } = await PartnersAPI.getOptionsAgentsByAgencyId(
          partnerId,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    buildParams(data) {
      const params = new URLSearchParams();
      Object.entries(data).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach(value => params.append(key, value.toString()));
        } else {
          params.append(key, value.toString());
        }
      });
      return params.toString();
    },
    getDirection: function(reservations = [], index) {
      if (reservations.length >= 5) {
        let position = reservations.length - index;
        if (position === 5) {
          return "down";
        } else {
          return position > 5 ? "down" : "up";
        }
      } else {
        return "down";
      }
    },
    getTableClass(reservations = []) {
      return reservations.length < 7 ? "b-table-separator" : "";
    },
    getUserId(user) {
      if (user) {
        return typeof user === "string" ? user : user._id;
      } else {
        return null;
      }
    },
    getTableClass(reservations = []) {
      return reservations.length < 7 ? "b-table-separator" : "";
    },
    async changDraggable(column) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        this.fields
      );
      if (status) {
        this.setSettings(settings);
      }
    },
    closeTableGridModal(status) {
      this.modalManageColumn = status;
    },
    togglesidebarhelp() {
      this.setsidebar - helpToggle(true);
    },
    openSideBar() {
      this.visibleSideBar = true;
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async saveColumnsInUserAccount(fields = []) {
      this.modalManageColumn = false;
      this.fields = fields;
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        this.fields
      );
      if (status) {
        this.$notify({
          type: "success",
          title: "Success!",
          message: "Columns have been changed",
          icon: "flaticon-check-3"
        });
        this.setSettings(settings);
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "Columns haven't been changed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async updateSettingLayoutsByUserId(userId, fields = []) {
      try {
        let { data } = await SettingsAPI.updateSettingLayoutsByUserId(
          userId,
          { "settings.reservations.tableLayouts": fields },
          this.sesion.token
        );
        if (data.status) {
          return { status: true, settings: data.data.settings };
        } else {
          return { status: false, settings: null };
        }
      } catch (error) {
        return { status: false, settings: null };
      }
    },
    populateFiles(settings) {
      try {
        if (settings) {
          if (settings.reservations.tableLayouts.length > 0) {
            return settings.reservations.tableLayouts;
          }
        }
        return RESERVATION_TABLE_DEFAULTS.filter(option => {
          return option.settings.default;
        });
      } catch (error) {
        return RESERVATION_TABLE_DEFAULTS.filter(option => {
          return option.settings.default;
        });
      }
    },
    async getReservationsMetrics(payload) {
      try {
        let { data } = await PartnersAPI.getReservationsMetrics(
          payload,
          this.sesion.token
        );
        if (data.status) {
          let { currentReservations, previousReservations } = data.data;
          this.initStatsCardPrimaryReservations(
            currentReservations,
            previousReservations
          );
          this.intiStatsCardPrimaryCancellations(
            currentReservations,
            previousReservations
          );
          this.intiStatsCardPrimaryPay(
            currentReservations,
            previousReservations
          );
          this.intiStatsCardPrimarySales(
            currentReservations,
            previousReservations
          );
        }
      } catch (error) {
        this.statsCardPrimary.reservations = {
          label: "Amount Reservations",
          percent: "0",
          count: "0",
          condition: "up"
        };
      }
    },
    getReservationsNumberMetrics(reservations = []) {
      return reservations.length;
    },
    getCancellationsMetrics(reservations = []) {
      return reservations.filter(reservation => {
        return reservation.status === "SBC" || reservation.status === "SCB";
      }).length;
    },
    getPayMetrics(reservations = []) {
      return reservations
        .filter(reservation => {
          return reservation.payment;
        })
        .map(reservation => reservation.pricing.totals.gross_price)
        .reduce((a, b) => a + b, 0);
    },
    getSalesMetrics(reservations = []) {
      return reservations
        .map(reservation => reservation.pricing.totals.gross_price)
        .reduce((a, b) => a + b, 0);
    },
    calculatePercentageDifference(currentValue, previousValue) {
      if (currentValue === 0 && previousValue === 0) {
        return 0;
      } else if (previousValue === 0) {
        return 0;
      } else {
        return ((currentValue - previousValue) / previousValue) * 100;
      }
    },
    initStatsCardPrimaryReservations(
      currentReservations = [],
      previousReservations = []
    ) {
      try {
        let currentReservationNumber = this.getReservationsNumberMetrics(
          currentReservations
        );
        let previousReservationNumber = this.getReservationsNumberMetrics(
          previousReservations
        );
        let percentageDifference = this.calculatePercentageDifference(
          currentReservationNumber,
          previousReservationNumber
        );
        this.statsCardPrimary.reservations = {
          label: "Amount Reservations",
          percent: Math.abs(percentageDifference).toFixed(2),
          count: `${currentReservationNumber}`,
          condition: `${percentageDifference >= 0 ? "up" : "down"}`
        };
      } catch (error) {
        this.statsCardPrimary.reservations = {
          label: "Amount Reservations",
          percent: "0",
          count: "0",
          condition: "up"
        };
        this.statsCardPrimary.pay = {
          label: "Total Payable",
          percent: "0",
          count: "0",
          condition: "up"
        };
        this.statsCardPrimary.sales = {
          label: "Total Sales",
          percent: "0",
          count: "0",
          condition: "up"
        };
        this.statsCardPrimary.cancellations = {
          label: "Amount Cancellations ",
          percent: "0",
          count: "0",
          condition: "up"
        };
      }
    },
    intiStatsCardPrimaryCancellations(
      currentReservations = [],
      previousReservations = []
    ) {
      try {
        let currentCancellations = this.getCancellationsMetrics(
          currentReservations
        );
        let previousCancellations = this.getCancellationsMetrics(
          previousReservations
        );

        let percentageDifference = this.calculatePercentageDifference(
          currentCancellations,
          previousCancellations
        );
        this.statsCardPrimary.cancellations = {
          label: "Amount Cancellations ",
          percent: Math.abs(percentageDifference).toFixed(2),
          count: `${currentCancellations}`,
          condition: `${percentageDifference >= 0 ? "up" : "down"}`
        };
      } catch (error) {
        this.statsCardPrimary.cancellations = {
          label: "Amount Cancellations ",
          percent: "0",
          count: "0",
          condition: "up"
        };
      }
    },
    intiStatsCardPrimaryPay(
      currentReservations = [],
      previousReservations = []
    ) {
      try {
        let currentPay = this.getPayMetrics(currentReservations);
        let previousPay = this.getPayMetrics(previousReservations);
        let percentageDifference = this.calculatePercentageDifference(
          currentPay,
          previousPay
        );
        this.statsCardPrimary.pay = {
          label: "Total Payable",
          percent: Math.abs(percentageDifference).toFixed(2),
          count: currentPay.toFixed(2),
          condition: `${percentageDifference >= 0 ? "up" : "down"}`
        };
      } catch (error) {
        this.statsCardPrimary.pay = {
          label: "Total Payable",
          percent: "0",
          count: "0",
          condition: "up"
        };
      }
    },
    intiStatsCardPrimarySales(
      currentReservations = [],
      previousReservations = []
    ) {
      try {
        let currentSales = this.getSalesMetrics(currentReservations);
        let previousSales = this.getSalesMetrics(previousReservations);
        let percentageDifference = this.calculatePercentageDifference(
          currentSales,
          previousSales
        );
        this.statsCardPrimary.sales = {
          label: "Total Sales",
          percent: Math.abs(percentageDifference).toFixed(2),
          count: currentSales.toFixed(2),
          condition: `${percentageDifference >= 0 ? "up" : "down"}`
        };
      } catch (error) {
        this.statsCardPrimary.sales = {
          label: "Total Sales",
          percent: "0",
          count: "0",
          condition: "up"
        };
      }
    },
    openReservationHistory(reservationId, bookingNumber) {
      this.tempReservationId = reservationId;
      this.tempBookingNumber = bookingNumber;
      this.showReservationHistory = true;
    },
    closeReservationHistoryModal() {
      this.showReservationHistory = false;
    },
    formatStatus(status) {
      if (status === "NW") {
        return "New";
      } else if (status === "SBC" || status === "SCB") {
        return "Cancelled";
      } else if (status === "SC") {
        return "Confirmed";
      } else if (status === "JF") {
        return "Completed";
      } else if (status === "SRB") {
        return "Rejected";
      } else if (status === "DA") {
        return "Driver Accepted";
      } else if (status === "DSR") {
        return "Driver Started Trip";
      } else if (status === "DAP") {
        return "Driver on Location";
      } else if (status === "POB") {
        return "POB";
      } else if (status === "NS") {
        return "No Show";
      } else if (status === "PNDG") {
        return "Pending";
      } else {
        return "Draft";
      }
    },
    getStatusPayment(
      payment,
      paymentType,
      paymentLinkStatus,
      reservationStatus
    ) {
      if (payment) {
        if (paymentLinkStatus === "refund") {
          return "Paid";
        } else {
          return "Paid";
        }
      } else {
        if (paymentType == "credit") {
          if (reservationStatus !== "PNDG") {
            return "On credit";
          } else {
            return "Unpaid";
          }
        } else {
          return "Unpaid";
        }
      }
    },
    getCustomerName(customer) {
      if (customer) {
        if (["business", "travel_agency"].indexOf(customer.type) > -1) {
          return customer.company_name
            ? customer.company_name
            : `${customer.first_name} ${customer.last_name}`;
        } else {
          return `${customer.first_name} ${customer.last_name}`;
        }
      } else {
        return "unknown";
      }
    },
    getPriceFormat(price) {
      return parseFloat(price.toFixed(2));
    },
    getBookingType(type) {
      if (type === "airport") {
        return "Airport Transfer";
      } else if (type === "arrival") {
        return "Airport Transfer (Arrival)";
      } else if (type === "departure") {
        return "Airport Transfer (Departure)";
      } else if (type === "station") {
        return "Station Transfer";
      } else if (type === "port") {
        return "Port Transfer";
      } else if (type === "hourly") {
        return "Hourly";
      } else if (type === "journey") {
        return "Journey";
      }
    },
    getFormatDate(date, format) {
      return moment
        .parseZone(date)
        .utc(true)
        .format(format);
    },
    getFormatTime(time, format) {
      return moment(time, ["hh:mm A"]).format(format);
    },
    getPassenger(passengers = [], passengersCount) {
      if (!lodash.isEmpty(passengers)) {
        let [passenger] =
          passengers.filter(passenger => passenger.primary) || passengers;
        if (passenger) {
          return `${passenger.fullName} ${
            passengersCount === 1 ? "" : `+ ${passengersCount - 1}`
          }`;
        }
      }
      return "Unassigned";
    },
    getReservationStatusFormat(status) {
      if (status === "NW") {
        return "New";
      } else if (status === "SBC" || status === "SCB") {
        return "Cancelled";
      } else if (status === "SC") {
        return "Confirmed";
      } else if (status === "JF") {
        return "Completed";
      } else if (status === "SRB") {
        return "Rejected";
      } else if (status === "DA") {
        return "Driver Accepted";
      } else if (status === "DSR") {
        return "Driver Started Trip";
      } else if (status === "DAP") {
        return "Driver on Location";
      } else if (status === "POB") {
        return "POB";
      } else if (status === "NS") {
        return "No Show";
      } else if (status === "PNDG") {
        return "Pending";
      } else {
        return "Draft";
      }
    },
    getPaymentStatus(payment, paymentType, reservationStatus) {
      if (payment) {
        return true;
      } else {
        if (paymentType == "credit") {
          if (reservationStatus !== "PNDG") {
            return "true";
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
    getCommisionByPartner(partner, totalGrossPrice) {
      try {
        if (
          ["travel_access", "travel_agency"].includes(partner.type) &&
          partner.type_charge === "commission"
        ) {
          let total = totalGrossPrice * (partner.commission / 100);
          return total.toFixed(2);
        } else {
          return "0.00";
        }
      } catch (error) {
        return "0.00";
      }
    },
    getReservationClass(reservationClass) {
      return reservationClass ? reservationClass : "Transfers";
    },
    getCurrenSymbolByCurrency(currency) {
      if (currency === "USD") {
        return "$";
      } else if (currency === "EUR") {
        return "€";
      } else if (currency === "GBP") {
        return "£";
      }
    },
    getCurrency(reservationClass, service, pricing) {
      if (reservationClass === "Transfers") {
        return {
          code: service ? service.currency_code : "",
          symbol: service ? service.currency_symbol : ""
        };
      } else {
        return {
          code: pricing.currency,
          symbol: this.getCurrenSymbolByCurrency(pricing.currency)
        };
      }
    },
    getSupplierName(reservationClass, supplier) {
      if (reservationClass === "Transfers") {
        return supplier.businessDetails.name;
      } else {
        return null;
      }
    },
    getPaymentReference(reservationClass, payment, paymentReference) {
      if (reservationClass === "Transfers") {
        return payment ? payment.transaction_id : paymentReference;
      } else {
        return null;
      }
    },
    getDriverName(reservationClass, driver) {
      if (reservationClass === "Transfers") {
        return driver
          ? `${driver.person.first_name} ${driver.person.last_name}`
          : null;
      } else {
        return null;
      }
    },
    goToEditReservation(reservation) {
      if (reservation.class === "Transfers") {
        return `/reservations/${reservation._id}`;
      } else {
        return `/reservations/${reservation._id}?productId=${reservation.productId}`;
      }
    },
    getTravelDate(availabilityId) {
      return availabilityId
        ? moment.parseZone(availabilityId).format("DD-MMM-YYYY")
        : "";
    },
    getStartTime(availabilityId) {
      return availabilityId
        ? moment.parseZone(availabilityId).format("hh:mm A")
        : "";
    },
    getContacts(contact, unitItems = []) {
      let paxNumber = unitItems.length;
      return `${contact.fullName} ${
        paxNumber === 1 ? "" : `+ ${paxNumber - 1}`
      }`;
    },
    getTotalCharge(reservationClass, pricing) {
      return reservationClass === "Transfers"
        ? this.getPriceFormat(pricing.totals.gross_price)
        : this.getProductPricing(pricing.retail, pricing.currencyPrecision);
    },
    getNetprice(reservationClass, pricing) {
      return reservationClass === "Transfers"
        ? this.getPriceFormat(pricing.totals.net_price)
        : this.getProductPricing(pricing.original, pricing.currencyPrecision);
    },
    getQuotedPrice(reservationClass, pricing) {
      return reservationClass === "Transfers"
        ? this.getPriceFormat(pricing.net_price.amount)
        : this.getProductPricing(pricing.original, pricing.currencyPrecision);
    },
    getGrossPrice(reservationClass, pricing) {
      return reservationClass === "Transfers"
        ? this.getPriceFormat(pricing.totals.gross_price)
        : this.getProductPricing(pricing.retail, pricing.currencyPrecision);
    },
    getNetProfit(reservationClass, pricing) {
      return reservationClass === "Transfers"
        ? this.getPriceFormat(pricing.totals.net_profit)
        : 0;
    },
    getTotalExtras(reservationClass, pricing) {
      return reservationClass === "Transfers"
        ? this.getPriceFormat(pricing.totals.extras.gross_price)
        : 0;
    },
    getTotalDiscounts(reservationClass, pricing) {
      return reservationClass === "Transfers"
        ? this.getPriceFormat(pricing.totals.discounts)
        : 0;
    },
    getProductPricing(amount, currencyPrecision) {
      let total = amount / Math.pow(10, currencyPrecision);
      return total.toFixed(2);
    },
    getLabelPax(unitItems = []) {
      let units = unitItems.map(e => e.unit.title);
      return [...new Set(units)]
        .map(item => {
          return `${units.filter(unit => unit === item).length} ${item}`;
        })
        .join(" <br> ");
    },
    getSourceProvider(source) {
      if (source.provider === "RHOMTRIP") {
        return "RhomTrip";
      } else if (source.provider === "VENTRATA") {
        return "Ventrata";
      }
      return "";
    },
    formatVehicleType(type) {
      if (type === "sedan") {
        return "Sedan";
      } else if (type === "boat") {
        return "Boat";
      } else if (type === "coach") {
        return "Coach";
      } else if (type === "limousine") {
        return "Limousine";
      } else if (type === "minibus") {
        return "Minibus";
      } else if (type === "midicoach") {
        return "Midicoach";
      } else if (type === "minivan") {
        return "Minivan";
      } else if (type === "mpv") {
        return "Mpv";
      } else if (type === "pickup") {
        return "Pickup";
      } else if (type === "premium_sedans") {
        return "Premium Sedans";
      } else if (type === "suvs") {
        return "SUVs";
      }
    },
    formatCategory(type) {
      if (type === "standard") {
        return "Standard Class";
      } else if (type === "business") {
        return "Business Class";
      } else {
        return "Luxury Class";
      }
    },
    /**
     *
     * Booking Action Methods
     */
    async handlerCancelReservation(
      bookingId,
      pickupDate,
      timeZone,
      cancellationPolicy,
      callback
    ) {
      const utcNow = moment.tz(timeZone).utc(true);
      let refundEligibility = resolveRefundEligibility(
        utcNow,
        pickupDate,
        cancellationPolicy
      );
      await cancelBooking(bookingId, refundEligibility, callback);
    },
    async cancelReservationById(reservationId, reason, refundEligibility) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.canlcelReservationById(
          reservationId,
          reason,
          refundEligibility,
          this.sesion.token
        );
        this.setLoad(false);
        let canceled = data.data;
        if (!canceled) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation can't be Cancelled",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation can't be cancelled");
      }
    },
    async confirmReservationById(reservationId) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.confimedReservations(
          reservationId,
          this.sesion.token
        );
        this.setLoad(false);
        let response = data.data;
        if (response.confirmed) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Reservation has been Confirmed",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Confirmed",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Confirmed");
      }
    },
    async updateBookingStatus(reservationId, status, reason = "") {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.changeRservationStatus(
          reservationId,
          status,
          reason,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          await this.get(
            true,
            this.limit,
            this.currentPage,
            this.queryTemp ? this.queryTemp : this.query
          );
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The reservation have been completed successfully",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The reservation could not be completed",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async handlerMarkReservationsAsPaid(bookings, callback) {
      const validationRules = [
        {
          check: hasPaidBookings,
          message:
            "You are trying to pay one or more reservations which have been paid"
        },
        {
          check: hasCanceledBookings,
          message:
            "You are trying to pay one or more reservations which have been cancelled"
        },
        {
          check: hasBookingsWithPaymentLink,
          message:
            "One or more of the selected reservations contains a valid payment link, wait until the payment link has expired"
        },
        {
          check: hasExpiredBookings,
          message:
            "You are trying to pay one or more reservations with an expired rate."
        }
      ];

      for (const rule of validationRules) {
        if (rule.check(bookings)) {
          this.$notify({
            type: "warning",
            title: "The Reservations cannot be Paid!",
            message: rule.message,
            icon: "flaticon-warning-1"
          });
          return;
        }
      }
      await markReservationsAsPaid(bookings, callback);
    },
    async markReservationsAsPaidById(reservations = []) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.markReservationsAsPaid(
          reservations,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          let { payments } = data.data;
          if (payments.reduce((a, b) => a && b, true)) {
            this.$notify({
              type: "success",
              title: "Success!",
              message: "The Reservations has been Paid",
              icon: "flaticon-check-3"
            });
            this.get(
              false,
              this.limit,
              this.currentPage,
              this.queryTemp ? this.queryTemp : this.query
            );
          } else {
            this.$notify({
              type: "danger",
              title: "Error!",
              message: "One or more reservations could not be paid",
              icon: "flaticon-remove"
            });
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservations cannot be Paid",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Paid");
      }
    },
    async resendEmailNotificationByBookingId(bookingId, recipients = []) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.resendEmailToUsersByReservationId(
          bookingId,
          recipients,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The notifications have been forwarded successfully",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The notifications couldn't be sent",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The operation couldn't be completed. Please try again"
        );
      }
    },
    async duplicateBookingById(bookingId, populate) {
      try {
        let { data } = await ReservationsAPI.getReservation(
          bookingId,
          populate,
          this.sesion.token
        );
        if (data.status) {
          let booking = removeTransferExcludedAttributes(
            lodash.cloneDeep(data.data)
          );
          this.setDuplicatedReservation(booking);
          this.$router.push("/reservations/new");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async downloadPDFType(bookingId, reference, isTransfer, pdfType, client) {
      try {
        let voucherType = isTransfer ? "product" : "transfer";
        this.setLoad(true);
        let { data } = await ReservationsAPI.downloadPDF(
          pdfType,
          bookingId,
          client,
          voucherType
        );
        this.setLoad(false);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${reference}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async downloadTickets(reservationId, client, bookingNumber) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.downloadPDFTickets(
          reservationId,
          client,
          "ALL",
          null
        );
        this.setLoad(false);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${bookingNumber}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async deleteBookingById(bookingId) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.deleteReservation(
          bookingId,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data.status) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Deleted!",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async bulkDeleteBookingsByIds(bookings = []) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.deleteReservationMany(
          bookings,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data.status) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservations cannot be Deleted!",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async otaConfirmReservationById(reservationId) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.otaConfirmReservationById(
          reservationId,
          {},
          this.sesion.token
        );
        this.setLoad(false);
        let response = data.data;
        if (response.confirmed) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Reservation has been Confirmed",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Confirmed",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Confirmed");
      }
    },
    async otaCancelBookingById(bookingId, reason = "") {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.otaCancelReservationById(
          bookingId,
          { reason: reason },
          this.sesion.token
        );
        this.setLoad(false);
        let response = data.data;
        if (response.canceled) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Reservation has been Cancelled",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Cancelled",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Cancelled");
      }
    },
    ...mapActions([
      "getSesion",
      "getOperatorsOptions",
      "getBranchesOptionsByOperatorId",
      "getReservations",
      "getLimit"
    ]),
    ...mapMutations([
      "setLoad",
      "setSigOut",
      "setItemsBread",
      "setResponseReservations",
      "setSesion",
      "setTempPagination",
      "setDuplicatedReservation",
      "setSettings"
    ])
  },
  destroyed() {
    clearTimeout(this.timeoutId);
  },
  computed: {
    reservations() {
      try {
        let reservations = this.responseReservations.docs || [];
        return reservations.map(reservation => {
          let reservationClass = this.getReservationClass(reservation.class);
          return {
            //Commons
            booking_number: reservation.booking_number,
            customer: this.getCustomerName(
              reservation.agent ? reservation.agent : reservation.customer
            ),
            passengers: reservation.passengers,
            payment: this.getStatusPayment(
              reservation.payment,
              reservation.payment_type,
              reservation.send_payment_link,
              reservation.status
            ),
            reservation_reference: reservation.booking_reference,
            deal_number: reservation.deal_number,
            invoice_n: reservation.invoice_number,
            payment_reference: this.getPaymentReference(
              reservationClass,
              reservation.payment,
              reservation.payment_reference
            ),
            status: this.formatStatus(reservation.status),

            //Transfer
            pickup_date: reservation.pickup_date,
            supplier: this.getSupplierName(
              reservationClass,
              reservation.supplier
            ),
            totalCharge: this.getTotalCharge(
              reservationClass,
              reservation.pricing
            ),
            netPrice: this.getNetprice(reservationClass, reservation.pricing),
            quotedPrice: this.getQuotedPrice(
              reservationClass,
              reservation.pricing
            ),
            grossPrice: this.getGrossPrice(
              reservationClass,
              reservation.pricing
            ),
            netProfit: this.getNetProfit(reservationClass, reservation.pricing),
            totalExtras: this.getTotalExtras(
              reservationClass,
              reservation.pricing
            ),
            totalDiscounts: this.getTotalDiscounts(
              reservationClass,
              reservation.pricing
            ),
            currency: this.getCurrency(
              reservationClass,
              reservation.service,
              reservation.pricing
            ),
            driver: this.getDriverName(reservationClass, reservation.driver),
            to: reservationClass === "Transfers" ? reservation.to : "",
            from: reservationClass === "Transfers" ? reservation.from : "",
            typeTransfer:
              reservationClass === "Transfers" ? reservation.type : "",
            passengersCount:
              reservationClass === "Transfers"
                ? reservation.passengersCount
                : "",
            flightNumber:
              reservationClass === "Transfers" ? reservation.flight_number : "",
            commission: reservation.commissions
              ? reservation.commissions.platform.amount
              : 0,
            class: reservationClass,
            referredBy: reservation.referredBy,
            stripeFee: reservation.commissions.payment_processor.amount || 0,
            reservation: reservation
          };
        });
      } catch (error) {
        console.error("Error formatting reservations:", error);
        return [];
      }
    },
    formattedItems() {
      return JSON.stringify(this.fields, null, 2);
    },
    ...mapGetters([
      "responseReservations",
      "sesion",
      "userRole",
      "load",
      "itemsBread",
      "operatorSelections",
      "branchesOptionsByOperatorId",
      "sigout",
      "paginationLimit",
      "tempPagination",
      "settings"
    ]),
    canUserDelete() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "DELETE");
    },
    canUserMarkBookingAsPaid() {
      return isUserAuthorized("RESERVATIONS", this.userRole, "MARK_AS_PAID");
    },
    formatD: function() {
      return "DD-MMM-YYYY";
    },
    formatT: function() {
      return "hh:mm A";
    },
    formatDateFlatPicker: function() {
      return "d-M-Y";
    },
    formatTimeFlatPicker: function() {
      return {
        altFormat: "G:i K",
        dateFormat: "G:i K",
        time_24hr: false
      };
    },
    today: function() {
      return moment().format("YYYY-MM-DD");
    },
    thisWeek: function() {
      return `${moment()
        .startOf("week")
        .format("YYYY-MM-DD")} to ${moment()
        .endOf("week")
        .format("YYYY-MM-DD")}`;
    },
    lastWeek: function() {
      return `${moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD")} to ${moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD")}`;
    },
    thisMonth: function() {
      return `${moment()
        .startOf("month")
        .format("YYYY-MM-DD")} to ${moment()
        .endOf("month")
        .format("YYYY-MM-DD")}`;
    },
    lastMonth: function() {
      return `${moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD")} to ${moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD")}`;
    },
    thisYear: function() {
      return `${moment()
        .startOf("year")
        .format("YYYY-MM-DD")} to ${moment()
        .endOf("year")
        .format("YYYY-MM-DD")}`;
    }
  }
};
</script>
